import React, { useEffect, useState } from "react";
import logo from "../assets/img/logo.svg";
import prev_arrow from "../assets/img/prev_arrow.svg";
import next_arrow from "../assets/img/next_arrow.svg";

const Step71 = ({ setStep, setFormdata, formData }) => {
  const [emailError, setEmailError] = useState(""); // State to hold error message

  const validateEmail = (email) => {
    // Regex for email validation
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const Next = () => {
    if (!formData?.email || !validateEmail(formData?.email)) {
      // Set error message if email is invalid
      setEmailError("Please enter a valid email address.");
    } else {
      // Clear error message and proceed to next step
      setEmailError("");
      setStep(8);
    }
  };


  // useEffect(()=>{
  //   setFormdata((prevState) => ({
  //     ...prevState,
  //     email: null, // Update the first name and keep the last name
  //   }));
  // },[])

  return (
    <>
      {/* <section class="step_wrapper"> */}
        <div class="top_logo_block">
          <div class="logo">
            <a href="">
              <img src={logo} alt="" />
            </a>
          </div>
        </div>

        <div class="step_body">
          <div class="step_form">
            <div class="form_block box_width_sm_two">
              <div class="input_fields margin_top_none">
                <input
                  type="email"
                  value={formData?.email}
                  onChange={(e) =>
                    setFormdata((prevState) => ({
                      ...prevState, // Keep all other fields the same
                      email: e.target.value, // Update the name field
                    }))
                  }
                  placeholder="Ex:Lincoln.1256@gmail.com"
                />
                 {emailError && <p className="error_txt" style={{color:"red"}}>{emailError}</p>} {/* Display error message */}
                <p class="sm_txt">
                  If the Email address is correct then proceed to the next step
                </p>
              </div>
            </div>
            <div class="btn_block">
              <a onClick={() => setStep(7)}>
                {" "}
                <img src={prev_arrow} alt="" /> <span>Prev</span>{" "}
              </a>
              <a onClick={() => Next()} class="nxt_btn">
                {" "}
                <span>next</span> <img src={next_arrow} alt="" />
              </a>
            </div>
          </div>
        </div>

        {/* <div class="bottom_steps">
          <ul class="for_desktop">
            <li class="step_done">
              <span>Referrals</span>
            </li>
            <li class="step_done">
              <span>Your details</span>
            </li>
            <li class="step_done">
              <span>Profession</span>
            </li>
            <li class="step_done">
              <span>Ideal Client</span>
            </li>
            <li class="step_done">
              <span>Good referral partners</span>
            </li>
            <li class="step_done">
              <span>Date of birth</span>
            </li>
            <li class="active">
              <span>Communication channel</span>
            </li>
            <li>
              <span>Hobbies</span>
            </li>
            <li>
              <span>Submit</span>
            </li>
          </ul>
          <div class="step_for_mob">
            <p>
              <span>7</span> of 9
            </p>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default Step71;
